import {
  broadcastToParent,
  RegisteredEventName
} from '@finanzcheck/catalyst-pollard'
import { COOKIE_KEY_FCID, getCookie } from 'utils/cookie'
import { Data } from 'interfaces/ApolloResponse.interface'
import { getOptimizelyTrackingAttribute } from 'utils/tracking'
import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'

export const trackTermsAndConditions = (data: Data) => {
  broadcastToParent({
    eventName: RegisteredEventName.tracking,
    data: {
      event: AmplitudeEvent.OnBedingungenClickedInVoucher,
      context: {
        Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
        ...getOptimizelyTrackingAttribute(data)
      }
    }
  })
}
